import { createAsyncThunk } from '@reduxjs/toolkit'

import { BackendLocation } from 'appTypes/shop'
import apiClient from 'helpers/clients/apiClient'
import i18n from 'utils/i18n'

import { displaySnackbar } from '../snackbar/snackbarSlice'

export const getLocations = createAsyncThunk<BackendLocation[]>(
  'getLocations',
  async (_, { dispatch, rejectWithValue }) => {
    const response = await apiClient.getLocations({
      active: true,
    })

    if (!response.success || !response.data) {
      dispatch(displaySnackbar({ message: i18n.t('error'), isError: true }))
      return rejectWithValue(response.error)
    }

    return response.data
  },
)
